/** Create-ticket requests use the v2 MT103 transfer types; later payloads keep the plain UI value. */
const MT103_CREATE_TICKET_TRANSFER_TYPES: Readonly<Record<string, string>> = {
  'Fund transfer 103': 'Fund transfer 103 v2',
  'Fund transfer 103 - HeadOffice': 'Fund transfer 103 v2 - HeadOffice',
};

const MT103_TRANSFER_TYPES_BY_CREATE_TICKET_TYPE: Readonly<Record<string, string>> = Object.fromEntries(
  Object.entries(MT103_CREATE_TICKET_TRANSFER_TYPES).map(([transferType, v2]) => [v2, transferType])
);

/** The v2 transfer types belong only to create-ticket requests; later payloads keep the plain MT103 value. */
export function toTransactionTransferType<T>(transferType: T): T | string {
  return (typeof transferType === 'string' && MT103_TRANSFER_TYPES_BY_CREATE_TICKET_TYPE[transferType]) || transferType;
}

export function buildCreateTicketPayload(data: Record<string, unknown>): Record<string, unknown> {
  const transferType = data['TransferType'] ?? data['transferType'];
  if (typeof transferType !== 'string') return data;
  const createTicketTransferType = Object.hasOwn(MT103_TRANSFER_TYPES_BY_CREATE_TICKET_TYPE, transferType)
    ? transferType
    : MT103_CREATE_TICKET_TRANSFER_TYPES[transferType];
  if (!createTicketTransferType) return data;

  const payload: Record<string, unknown> = { ...data, TransferType: createTicketTransferType };
  delete payload['transferType'];
  return payload;
}
